import React, { useEffect, useState } from "react";
import {
    Dialog,
    DialogContent,
    DialogTitle,
    TextField,
    List,
    ListItem,
    ListItemText,
    makeStyles,
} from "@material-ui/core";

import { useSelector } from "react-redux";
import { getCleanedString } from "../../../../services/utils";

const useStyles = makeStyles({
    input: {
        fontSize: "30px",
    },
    label: {
        fontSize: "20px",
    },
});

const BuscadorManual = ({ open, onClose, onSeleccion }) => {
    const classes = useStyles();

    const [lista, setLista] = useState([]);
    const [filtro, setFiltro] = useState("");

    const eventParticipants = useSelector(
        (state) => state.registry.eventParticipants
    );

    useEffect(() => {
        if (!open) return;

        const data = eventParticipants || {};

        const arr = Object.keys(data)
            .filter(
                (key) =>
                    data[key].numero !== undefined &&
                    data[key].numero !== null &&
                    data[key].numero !== ""
            )
            .map((key) => ({
                ...data[key],
                id: key,
            }));

        setLista(arr);
        setFiltro("");
    }, [open, eventParticipants]);

    const buscarParticipantes = () => {
        if (filtro == null) {
            return [];
        }

        const valorOriginal = filtro.toString().trim();

        if (valorOriginal === "") {
            return [];
        }

        // ==========================================
        // BÚSQUEDA POR NÚMERO
        // ==========================================
        // Si todo lo escrito es numérico,
        // únicamente busca coincidencia EXACTA
        if (!isNaN(valorOriginal)) {
            return lista.filter((participante) => {
                if (
                    participante.numero === undefined ||
                    participante.numero === null
                ) {
                    return false;
                }

                return participante.numero.toString() === valorOriginal;
            });
        }

        // ==========================================
        // BÚSQUEDA POR TEXTO
        // ==========================================
        // Igual que el buscador anterior:
        // exigimos al menos 3 caracteres.
        if (valorOriginal.length <= 2) {
            return [];
        }

        const valorBuscado = getCleanedString(valorOriginal).toUpperCase();

        return lista.filter((participante) => {
            const nombres = participante.nombres || "";
            const apellidos = participante.apellidos || "";
            const correo = participante.correo || "";
            const id = participante.id || "";

            const textoComparar = getCleanedString(
                nombres.toUpperCase() +
                " " +
                apellidos.toUpperCase() +
                " " +
                correo.toUpperCase() +
                " " +
                id
            );

            return textoComparar.includes(valorBuscado);
        });
    };

    const filtrados = buscarParticipantes();

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Buscar participante</DialogTitle>

            <DialogContent>
                <TextField
                    label="Buscar por nombre, número o correo"
                    fullWidth
                    autoFocus
                    value={filtro}
                    onChange={(e) => setFiltro(e.target.value)}
                    InputProps={{
                        style: {
                            fontSize: "30px",
                        },
                    }}
                    style={{
                        marginBottom: 16,
                    }}
                />

                <List>
                    {filtrados.map((participante) => (
                        <ListItem
                            button
                            key={participante.id}
                            onClick={() => {
                                onSeleccion(participante);
                                onClose();
                            }}
                        >
                            <ListItemText
                                primary={`${participante.numero !== undefined &&
                                    participante.numero !== null
                                    ? participante.numero
                                    : "Registro Incompleto"
                                    } - ${(participante.nombres || "").toUpperCase()} ${(
                                        participante.apellidos || ""
                                    ).toUpperCase()}`}
                                secondary={""}
                            />
                        </ListItem>
                    ))}
                </List>
            </DialogContent>
        </Dialog>
    );
};

export default BuscadorManual;